module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIzZDNhNTM1ODZiZDc4ZDEwNjlhZTRiODlhM2I5YWE5OC5zdmciOw=="